module.exports = __webpack_public_path__ + "static/aloopaccordion-d408b52fee8e826919832af53c3810fd.png";